const LINK_USER_GUIDE = ['/ui/user-guide/contact', '/ui/user-guide/search', '/ui/user-guide/index']

export default LINK_USER_GUIDE;
